import React from 'react';
import './ourServices.scss';

const DigitalizacionServices = () => {
  return (
    <div className="our-services">
      <div className="our-services__container">
        <div className="our-services__content">
          <h2 className="our-services__title">Consultoría Neuropsicológica</h2>
          <div className="our-services__title-line" />
          <p className="our-services__text">
            Optimizamos producciones audiovisuales aplicando neuropsicología
            científica a guiones, personajes y dinámicas de equipo.
          </p>
          <p className="our-services__text">
            Nuestro servicio de consultoría neuropsicológica está diseñado para
            acompañar a productoras y equipos creativos en cada fase del proceso
            audiovisual. Analizamos guiones, construcción de personajes y
            dinámicas grupales desde una perspectiva neuro-psicológica para
            mejorar la profundidad emocional de las narrativas y el rendimiento
            de los equipos.
          </p>
          <p className="our-services__text">
            Utilizando IA y Business Intelligence, convertimos datos emocionales
            y conductuales en conocimiento accionable que permite tomar
            decisiones más creativas, precisas y estratégicas en cada
            producción.
          </p>
        </div>
        <div className="our-services__solutions">
          <h3 className="our-services__subtitle">
            Entre nuestras soluciones se incluyen:
          </h3>
          <ul className="our-services__list">
            <li className="our-services__item">
              <p className="our-services__item-title">
                Análisis neuropsicológico de guiones
              </p>
              <p className="our-services__item-desc">
                Evaluamos la estructura narrativa y el arco emocional del guión
                para maximizar el impacto en el espectador.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Construcción de personajes con profundidad psicológica
              </p>
              <p className="our-services__item-desc">
                Aplicamos principios neuropsicológicos para desarrollar
                personajes más complejos, creíbles y emocionalmente resonantes.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Optimización de dinámicas de equipo
              </p>
              <p className="our-services__item-desc">
                Analizamos y mejoramos la coordinación y comunicación de los
                equipos de producción desde un enfoque neuropsicológico.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Informes neuropsicológicos de producción
              </p>
              <p className="our-services__item-desc">
                Elaboramos informes detallados sobre montaje, arousal emocional,
                música y postproducción basados en evidencia científica.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Acompañamiento en set y a distancia
              </p>
              <p className="our-services__item-desc">
                Ofrecemos dos modalidades de integración: presencial en el set o
                mediante análisis y consultoría a distancia.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DigitalizacionServices;
